import { Button, CircularProgress, Tooltip } from "@mui/material";
import { ActionButtonProps, ActionButtonsProps } from "./types";

export const ActionButton = ({ text, disabled, icon, tooltip, hide, loading, props }: ActionButtonProps) => {
  if (hide) return null;

  return (
    <Tooltip title={tooltip || ""}>
      <span>
        <Button {...props} disabled={disabled} startIcon={icon} endIcon={loading ? <CircularProgress size={20} /> : null}>
          {text}
        </Button>
      </span>
    </Tooltip>
  );
};

const ActionButtons = ({ submit, cancel, additionalActions, handleClose, posting = false, mode, formRef, formId }: ActionButtonsProps) => {
  return (
    <>
      {cancel && (
        <ActionButton
          {...cancel}
          disabled={cancel.disabled || posting}
          text={cancel?.text || "Cancel"}
          props={{
            ...cancel.props,
            variant: "outlined",
            onClick: handleClose,
          }}
        />
      )}

      <ActionButton
        {...submit}
        disabled={submit.disabled || posting}
        text={submit?.text || (mode.toLowerCase() === "add" ? "Add" : "Save Changes")}
        props={{
          ...submit.props,
          variant: "contained",
          type: "submit",
          form: formId,
        }}
      />

      {additionalActions &&
        (additionalActions?.length || 0) > 0 &&
        additionalActions.map((actionButton, i) => (
          <ActionButton
            key={`action-button-${i}`}
            text={actionButton.text || ""}
            {...actionButton}
            disabled={actionButton.disabled || posting}
            props={{
              ...actionButton.props,
              form: formId,
              onClick: (event) => {
                actionButton?.props?.onClick && actionButton.props.onClick(event);

                if (actionButton.triggerSubmit) {
                  formRef?.current && formRef.current?.requestSubmit(event.currentTarget);
                }
              },
            }}
          />
        ))}
    </>
  );
};

export default ActionButtons;
